/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SubscriberBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SubscriberBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.SubscriberBean = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.SubscriberBean);
  }
}(this, function(ApiClient, SubscriberBean) {
  'use strict';

  /**
   * The SubscriberBean model module.
   * @module model/SubscriberBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>SubscriberBean</code>.
   * @alias module:model/SubscriberBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>SubscriberBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriberBean} obj Optional instance to populate.
   * @return {module:model/SubscriberBean} The populated <code>SubscriberBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = SubscriberBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('messages'))
        obj.messages = ApiClient.convertToType(data['messages'], ['String']);
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('platform'))
        obj.platform = ApiClient.convertToType(data['platform'], 'String');
      if (data.hasOwnProperty('privateKeyFile'))
        obj.privateKeyFile = ApiClient.convertToType(data['privateKeyFile'], 'String');
      if (data.hasOwnProperty('projectId'))
        obj.projectId = ApiClient.convertToType(data['projectId'], 'String');
      if (data.hasOwnProperty('projectName'))
        obj.projectName = ApiClient.convertToType(data['projectName'], 'String');
      if (data.hasOwnProperty('serviceAccount'))
        obj.serviceAccount = ApiClient.convertToType(data['serviceAccount'], 'String');
      if (data.hasOwnProperty('topicId'))
        obj.topicId = ApiClient.convertToType(data['topicId'], 'String');
      if (data.hasOwnProperty('topicName'))
        obj.topicName = ApiClient.convertToType(data['topicName'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {module:model/SubscriberBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {Array.<String>} messages
   */
  exports.prototype.messages = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} platform
   */
  exports.prototype.platform = undefined;

  /**
   * @member {String} privateKeyFile
   */
  exports.prototype.privateKeyFile = undefined;

  /**
   * @member {String} projectId
   */
  exports.prototype.projectId = undefined;

  /**
   * @member {String} projectName
   */
  exports.prototype.projectName = undefined;

  /**
   * @member {String} serviceAccount
   */
  exports.prototype.serviceAccount = undefined;

  /**
   * @member {String} topicId
   */
  exports.prototype.topicId = undefined;

  /**
   * @member {String} topicName
   */
  exports.prototype.topicName = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/SubscriberBean.js